function load_tooltips() {
    const tooltip = document.createElement('div');
    tooltip.className = 'tooltip';
    document.querySelector(".landing").appendChild(tooltip);

    $('[data-tooltip]').hover(function() {
        tooltip.textContent = this.dataset.tooltip || '';
        tooltip.style.top = this.getBoundingClientRect().bottom + 'px';
        tooltip.style.left = this.getBoundingClientRect().left + 'px';
        tooltip.style.display = 'block';
    }, function() {
        tooltip.style.display = 'none';
    });
}

/** dépend de https://calendar.google.com/calendar/scheduling-button-script.js */
function load_calendar_buttons() {
    document.querySelectorAll('button.gcalendar').forEach(function(el) {
        var target = el;
        window.calendar.schedulingButton.load({
            url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1kwxe_7jjMLmGlGKIsNLS9MId3gvPBv-Cr5sqfoOQkX7rpAWgCdUkUY-e4u0CfQHP_kHNJjXJs?gv=true',
            color: '#238ac2',
            label: 'Planifier une démo personnalisée',
            target,
        });

        target.remove();
    });

    // supprime le style inline ajouté par le script
    setTimeout(function() {
        document.querySelectorAll('.qxCTlb').forEach(/** @param {HTMLElement} button */ button => { button.style.backgroundColor = '', button.style.color = ''; });
    }, 1000);

    $('.qxCTlb').on('click', '.gta', function() {
        window.dataLayer.push({ 'event': 'request_demo' });
    });
}

(function() {
    window.addEventListener('load', function() {
        if (!document.querySelector('.landing')) return;
        load_tooltips();
        load_calendar_buttons();
    });
})();